
import { Recorder } from './Recorder';
type AudioDataCallBack = (audiochunk: any[]) => any;

export default class AudioRecorder implements Recorder {
  // private mrecorder!: any;
  private microphone!: MediaStreamAudioSourceNode;
  private processor!: ScriptProcessorNode;
  private bufferArray: Float32Array[] = []
  private audioChunkCallBack: AudioDataCallBack;
  private AudioContext!: AudioContext;
  constructor(callback: AudioDataCallBack) {
    this.audioChunkCallBack = callback;
  }
  public StopRecording() {
    if (this.processor && this.microphone) {
      this.microphone.disconnect();
      this.processor.disconnect();
      this.microphone.mediaStream.getTracks().forEach((i: any) => i.stop());
    }
  }
  public StartRecording() {
    if (this.processor && this.microphone) {
      this.bufferArray = [];
      this.microphone.connect(this.processor);
      this.processor.connect(this.AudioContext.destination);
    }
  }

  public downsample(buffer: Float32Array, sampleRate: number, outSampleRate: number): any {
    if (outSampleRate === sampleRate) {
      return buffer;
    }
    if (outSampleRate > sampleRate) {
      throw new Error("downsampling rate show be smaller than original sample rate");
    }
    let sampleRateRatio = sampleRate / outSampleRate;
    let newLength = Math.round(buffer.length / sampleRateRatio);
    let result = new Int16Array(newLength);
    let offsetResult = 0;
    let offsetBuffer = 0;
    while (offsetResult < result.length) {
      let nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
      let accum = 0
      let count = 0;
      for (let i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
        accum += buffer[i];
        count++;
      }

      result[offsetResult] = Math.min(1, accum / count) * 0x7FFF;
      offsetResult++;
      offsetBuffer = nextOffsetBuffer;
    }
    return result.buffer;
  }
  public Setup(): Promise<any> {
    let p = new Promise((resolve, reject) => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      
      navigator.mediaDevices
        .getUserMedia({
          audio: true
        }).then(stream => {
          this.AudioContext = new AudioContext()
          let bufSize = 16384
          this.microphone = this.AudioContext.createMediaStreamSource(stream)
          this.processor = this.AudioContext.createScriptProcessor(bufSize, 1, 1)
          this.processor.onaudioprocess = (event) => {
            let toPCM = this.downsample(event.inputBuffer.getChannelData(0), this.AudioContext.sampleRate, 16000)
            this.audioChunkCallBack(toPCM)
          }
          resolve();
        })
        .catch(err => reject(err));
      } else {
        console.log("getUserMedia not supported on your browser!");
      }
      });
          //console.log("The following getUserMedia error occured: " + err);
        //);
    return p; 
  }

  public releaseResources() {
    // this.mstream.getTracks().forEach((i: any) => i.stop());
    // this.microphone.mediaStream.getTracks().forEach((i: any) => i.stop());
  }

  // private onStop() {
  //   console.log("recorder stopped");
  //   const audio = document.getElementById("audioclip") as HTMLAudioElement;
  //   console.log(this.chunks.length);
  //   const blob = new Blob(this.chunks);
  //   const audioURL = window.URL.createObjectURL(blob);
  //   audio.src = audioURL;
  //   console.log(audioURL);
  // }

  // private toFloatArray(buffer: any) {

  //   if (!buffer || !buffer.length) {
  //     return new Float32Array();
  //   }

  //   if (buffer.toArrayBuffer) {
  //     // Node 0.12+
  //     return new Float32Array(buffer.toArrayBuffer());
  //   } else {
  //     // Node <0.12
  //       const len = buffer.length, i,
  //       arrayBuffer = new ArrayBuffer(len),
  //       view = new Uint8Array(arrayBuffer);

  //     for (i = 0; i < len; ++i) {
  //       view[i] = buffer[i];
  //     }

  //     return new Float32Array(arrayBuffer);
  //   }
  // }
}
